import { render } from "./footerComp.vue?vue&type=template&id=58770977"
import script from "./footerComp.vue?vue&type=script&lang=js"
export * from "./footerComp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\workspace\\repository\\sprfidspring\\src\\main\\vue-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__